import { query as originQuery } from '../metricsData/schema';
import { createJsonTransformOptions } from '../../metricsChartContainer/query';
import { jsonTransform } from '@utils';
import { KPIChartTransformOption } from './kpiChartTransformOption';

const metricNameKey = '_metric';

const createQuery = (metricName, interval, filter, granularity, kpiConfig) => {
  const query = {
    ...originQuery,
    interval,
    filter,
    granularity,
    metrics: metricName
  };

  query.options.kpiConfig = kpiConfig;

  return {
    queries: [
      query
    ]
  };
}

const formatData = ({ response, metrics, filterColor, allMetrics }) => {
  const chartData = {};
  try {
    if ( response ) {
      const data = jsonTransform(
        response,
        KPIChartTransformOption(metrics, filterColor),
        createJsonTransformOptions(metrics, null, allMetrics),
      );

      data.out.forEach(metricData => {
        metricData.id = metricData[metricNameKey];
        chartData[metricData.id] = metricData;
      });
    }
  } catch (err) {
    // ignore
  }
  return chartData;
}

export {
  createQuery,
  formatData,
};
